import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGE_CONFIG } from '../constants/language-config.constant';

@Component({
    selector: 'nav-strip',
    templateUrl: './nav-strip.component.html',
    styleUrl: './nav-strip.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class NavStripComponent implements OnInit {
    private defaultFontSize = 16;

    activeButton: 'decrease' | 'reset' | 'increase' | null = null;
    protected activeTheme: 'light' | 'dark' = 'light';
    protected languageConfig = LANGUAGE_CONFIG;
    protected languageControl = new FormControl<typeof LANGUAGE_CONFIG[0]>(LANGUAGE_CONFIG[0], { nonNullable: true });

    constructor(
        private renderer: Renderer2,
        private translate: TranslateService,
        @Inject(DOCUMENT) private document: Document
    ) { }

    ngOnInit () {
        this.translate.use(this.languageConfig[0].langCode);
        this.languageControl.valueChanges.subscribe(value => this.translate.use(value.langCode));
    }

    changeFontSize(action: 'decrease' | 'reset' | 'increase') {
    if (action === 'reset') {
      this.defaultFontSize = 16;
    } else if (action === 'decrease' && this.defaultFontSize > 10) {
      this.defaultFontSize -= 1;
    } else if (action === 'increase' && this.defaultFontSize < 22) {
      this.defaultFontSize += 1;
    }
    this.renderer.setStyle(this.document.documentElement, 'font-size', `${this.defaultFontSize}px`);
    this.renderer.setStyle(this.document.body, 'font-size', `${this.defaultFontSize}px`);
    this.applyGlobalStyle(this.defaultFontSize);
  }

  applyGlobalStyle(fontSize: number) {
    const safeFontSize = Math.min(22, Math.max(10, fontSize));
    const css = `html, body { font-size: ${safeFontSize}px !important; }`;
    let styleTag = this.document.getElementById('global-font-size');
    if (!styleTag) {
      styleTag = this.renderer.createElement('style');
      this.renderer.setAttribute(styleTag, 'id', 'global-font-size');
      this.renderer.appendChild(this.document.head, styleTag);
    }
    this.renderer.setProperty(styleTag, 'textContent', css);
  }

    changeTheme (theme: 'light' | 'dark') {
        if (theme === 'light') {
            this.renderer.addClass(this.document.body, 'dark-theme');
            this.activeTheme = 'dark';
        } else {
            this.renderer.removeClass(this.document.body, 'dark-theme');
            this.activeTheme = 'light';
        }
    }

    getNavigatorLanguage () {
        return (new Intl.NumberFormat()).resolvedOptions().locale.split('-')[0];
    }
}
